/**
 * Let a notification card be flicked away: it follows the finger (or mouse)
 * sideways, or upwards with `up`, and past a threshold flies off and calls
 * `onDismiss`; otherwise it springs back.
 */
export function makeSwipeable(el: HTMLElement, onDismiss: () => void, up = false): void {
  let id = -1;
  let startX = 0;
  let startY = 0;
  let dx = 0;
  let dy = 0;
  el.style.touchAction = 'none';
  el.addEventListener('pointerdown', (e) => {
    id = e.pointerId;
    startX = e.clientX;
    startY = e.clientY;
    dx = 0;
    dy = 0;
    el.setPointerCapture(id);
    el.style.transition = 'none';
    e.stopPropagation();
  });
  el.addEventListener('pointermove', (e) => {
    if (e.pointerId !== id) return;
    dx = e.clientX - startX;
    dy = up ? Math.min(0, e.clientY - startY) : 0;
    el.style.translate = `${dx}px ${dy}px`;
    el.style.opacity = String(1 - Math.min(1, Math.hypot(dx, dy) / (el.offsetWidth * 0.8)));
  });
  const end = (e: PointerEvent): void => {
    if (e.pointerId !== id) return;
    id = -1;
    const upward = dy < -40 && -dy > Math.abs(dx);
    const gone = upward || Math.abs(dx) > el.offsetWidth * 0.3;
    el.style.transition = 'translate 0.2s ease-in, opacity 0.2s';
    if (!gone) {
      el.style.translate = '';
      el.style.opacity = '';
      window.setTimeout(() => (el.style.transition = ''), 200);
      return;
    }
    el.style.translate = upward ? '0 -160%' : `${Math.sign(dx) * 120}% 0`;
    el.style.opacity = '0';
    window.setTimeout(() => {
      onDismiss();
      el.style.transition = '';
      el.style.translate = '';
      el.style.opacity = '';
    }, 200);
  };
  el.addEventListener('pointerup', end);
  el.addEventListener('pointercancel', end);
}
